import { type FC, type ReactNode, useRef } from "react";

import { DEPRECATED_useTooltip as useTooltip } from "../../hooks/DEPRECATED_useTooltip.ts";
import { SymbolIcon } from "../Icon/SymbolIcon.tsx";
import { TooltipIntent } from "../Tooltip/settings.ts";
import { Tooltip } from "../Tooltip/Tooltip.tsx";
import { TriggerButtonSize } from "../TriggerButton/settings.ts";
import { TriggerButton } from "../TriggerButton/TriggerButton.tsx";
import style from "./InfoToggletip.module.css";

export interface InfoToggletipProps {
  title?: string;
  content: ReactNode;
}

/**
 * A blue info icon (i) with a popover tooltip.
 */
export const InfoToggletip: FC<InfoToggletipProps> = (props) => {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const { triggerProps, tooltipProps, arrowProps, state } = useTooltip(triggerRef, tooltipRef, {
    delay: 0,
    trigger: "focus",
    offset: 7,
    isDismissable: true,
    onClose,
  });

  function onClose() {
    state.close(true);
  }

  return (
    <div className={style.container}>
      {/*FIXME*/}
      {/*@ts-expect-error useTooltip deprecated */}
      <TriggerButton
        {...triggerProps}
        icon={<SymbolIcon icon={"help"} aria-hidden size={14} className={style.icon} filled />}
        label={""}
        ref={triggerRef}
        size={TriggerButtonSize.Small}
        onPress={() => {
          state.open(true);
        }}
        className={style.button}
      />
      {!!state.isOpen && (
        <Tooltip
          title={props.title}
          content={props.content}
          domProps={tooltipProps}
          arrowProps={arrowProps}
          ref={tooltipRef}
          intent={TooltipIntent.Info}
        />
      )}
    </div>
  );
};
